import { useDispatch, useSelector } from "react-redux";

import { Link } from "react-router-dom";
import { renderStatus } from "../../../../Utils/CommonUtils";

const useOrganizationColumn = () => {
  const dispatch = useDispatch();
  const organizationColumns = [
    {
      header: "Code",
      accessorKey: "code",
      cell: (props) => (
        <Link
          className="table-drilling-link"
          to={`/org/org/update/${props.row.original.organizationid}`}
        >
          {props?.getValue() ? props?.getValue() : "-"}
        </Link>
      ),
      size: 80,
    },
    {
      header: "Name",
      accessorKey: "name",
      cell: (props) => (props?.getValue() ? props?.getValue() : "-"),
      size: 250,
    },
    {
      header: "Contact Number",
      accessorKey: "contact_number",
      cell: (props) => (props?.getValue() ? props?.getValue() : "-"),
      size: 200,
    },
    // {
    //   header: "Created Date",
    //   accessorKey: "created_date",
    //   // cell: (props) => {
    //   //   {props?.getValue() ? props?.getValue() : "-"}
    //   // },
    //   size: 200,
    // },
    {
      header: "Email",
      accessorKey: "email",
      cell: (props) => (props?.getValue() ? props?.getValue() : "-"),
      size: 300,
    },

    {
      header: "Status",
      accessorKey: "status",
      cell: (props) =>
        props?.getValue() ? renderStatus(props?.getValue()) : "-",
      size: 150,
    },
    // {
    //   header: "Action",
    //   accessorKey: "action",
    //   cell: (props) => (
    //     <div className="action-icons text-center">
    //       <span
    //         // className="btn btn-sm btn-soft-info edit-list"
    //         onClick={() => {
    //           dispatch(openModal(true));
    //           dispatch(editModal(true));
    //           dispatch(updateRendererFormState(props?.row?.original));
    //           dispatch(setUserEditID(props?.row?.original?.entityid));
    //           // dispatch(setUserEditCode(props?.row?.code));
    //         }}
    //       >
    //         {/* <i className="ri-pencil-fill align-bottom" /> */}
    //         <EditListIcon />
    //       </span>
    //     </div>
    //   ),
    //   meta: { align: "center" },
    //   size: 100,
    // },
  ];

  return { organizationColumns };
};

export default useOrganizationColumn;
